export default __webpack_public_path__ + "static/media/el7.0237e84a.svg";